// extracted by mini-css-extract-plugin
module.exports = {"custom-audio-slider":"components_custom-audio-slider__wV76V"};